import React from 'react';

import BreederProfileTestimonialsSection from 'dpl/components/BreederProfile/Show/BreederProfileTestimonialsSection';
import BreederProfileCurrentPuppiesSectionContainer from 'dpl/containers/BreederProfile/Show/BreederProfileCurrentPuppiesSectionContainer';
import BreederProfileLittersSectionContainer from 'dpl/containers/BreederProfile/Show/BreederProfileLittersSectionContainer';
import BreederProfileAdoptionProcessSectionContainer from 'dpl/containers/BreederProfile/Show/BreederProfileAdoptionProcessSectionContainer';
import BreederProfileDeliverySectionContainer from 'dpl/containers/BreederProfile/Show/BreederProfileDeliverySectionContainer';
import BreederProfileAboutPuppiesSectionContainer from 'dpl/containers/BreederProfile/Show/BreederProfileAboutPuppiesSectionContainer';
import BreederProfileHealthTestsSectionContainer from 'dpl/containers/BreederProfile/Show/BreederProfileHealthTestsSectionContainer';
import BreederProfileParentsSectionContainer from 'dpl/containers/BreederProfile/Show/BreederProfileParentsSectionContainer';
import BreederProfilePhotosSectionContainer from 'dpl/containers/BreederProfile/Show/BreederProfilePhotosSectionContainer';
import BreederProfileMoreAboutBreederSectionContainer from 'dpl/containers/BreederProfile/Show/BreederProfileMoreAboutBreederSectionContainer';
import BreederProfileRelatedBreedsContainer from 'dpl/containers/BreederProfile/Show/BreederProfileRelatedBreedsContainer';

const SECTIONS = [
  {
    key: 'current-puppies',
    className: 'bg-subtle-light-gray',
    Component: BreederProfileCurrentPuppiesSectionContainer
  },
  {
    key: 'litters',
    className: 'bg-subtle-light-gray',
    Component: BreederProfileLittersSectionContainer
  },
  {
    key: 'adoption-process',
    className: 'bg-subtle-light-gray',
    Component: BreederProfileAdoptionProcessSectionContainer
  },
  {
    key: 'about-puppies',
    className: 'bg-subtle-light-gray',
    Component: BreederProfileAboutPuppiesSectionContainer
  },
  {
    key: 'delivery',
    className: 'bg-subtle-light-gray',
    Component: BreederProfileDeliverySectionContainer
  },
  {
    key: 'more-about-breeder',
    Component: BreederProfileMoreAboutBreederSectionContainer
  },
  {
    key: 'parents',
    Component: BreederProfileParentsSectionContainer
  },
  {
    key: 'health-tests',
    Component: BreederProfileHealthTestsSectionContainer
  },
  {
    key: 'owner-stories',
    Component: BreederProfileTestimonialsSection
  },
  {
    key: 'photos',
    className: 'bg-subtle-light-gray',
    Component: BreederProfilePhotosSectionContainer
  },
  {
    key: 'related-breeds',
    Component: BreederProfileRelatedBreedsContainer
  }
];

export default function BreederProfileLayoutContainer() {
  return (
    <ul className="BreederProfileLayoutContainer">
      {SECTIONS.map(({ key, className, Component }) => (
        <li key={key} className={className}>
          <Component />
        </li>
      ))}
    </ul>
  );
}
